module.exports = __webpack_public_path__ + "assets/img/lvbo.ef9652d7.png";